/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type TestDetectionRuleRequestBody = {
  /**
   * CEL detection predicate for `custom.*` rule ids, evaluated against the sample message.
   */
  detectionExpr?: string | undefined;
  /**
   * Rule identifier to evaluate (e.g. `secret.aws_access_token`, `pii.email_address`, `custom.acme_token`).
   */
  ruleId: string;
  /**
   * Sample text to scan.
   */
  text: string;
};

/** @internal */
export type TestDetectionRuleRequestBody$Outbound = {
  detection_expr?: string | undefined;
  rule_id: string;
  text: string;
};

/** @internal */
export const TestDetectionRuleRequestBody$outboundSchema: z.ZodMiniType<
  TestDetectionRuleRequestBody$Outbound,
  TestDetectionRuleRequestBody
> = z.pipe(
  z.object({
    detectionExpr: z.optional(z.string()),
    ruleId: z.string(),
    text: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      detectionExpr: "detection_expr",
      ruleId: "rule_id",
    });
  }),
);

export function testDetectionRuleRequestBodyToJSON(
  testDetectionRuleRequestBody: TestDetectionRuleRequestBody,
): string {
  return JSON.stringify(
    TestDetectionRuleRequestBody$outboundSchema.parse(
      testDetectionRuleRequestBody,
    ),
  );
}
